<template>
  <div class="weather-station">
    <!--选择气象站-->
    <div class="tip-text">气象站</div>
    <div class="station-name">{{ stationName }}</div>
    <div class="station-select">
      <el-select v-model="activeStationID" placeholder="请选择">
        <el-option
          v-for="(item,index) in stationList"
          :key="index"
          :label="item.StationName"
          :value="item.StationID">
        </el-option>
      </el-select>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['stationList'],
    data(){
      return {
        activeStationID: ''
      };
    },
    watch: {
      activeStationID(){
        this.$emit('station-change', this.activeStationID);
      }
    },
    computed: {
      stationName(){
        const matchItem = this.stationList.find(item => item.StationID === this.activeStationID);
        if (matchItem) {
          return matchItem.StationName;
        }
      }
    },
    methods: {
      setActive(station){
        this.activeStationID = station.StationID;
      }
    }
  }
</script>
<style rel="stylesheet/less" lang="less" scoped>
  .weather-station {
    font-size: 0;
  }

  .tip-text, .station-name, .station-select {
    display: inline-block;
    vertical-align: top;
  }

  .tip-text {
    font-size: 24px;
    color: #ffffff;
    font-weight: bolder;
    line-height: 40px;
    margin-left: 40px;
  }

  .station-name {
    font-size: 24px;
    color: #ffffff;
    line-height: 40px;
    margin-left: 30px;
  }

  .station-select {
    margin-left: 15px;
    display: inline-block;
    vertical-align: top;
    height: 36px;
    margin-top: 2px;
  }
</style>



// WEBPACK FOOTER //
// weather-station.vue?0d299a9a